(function () {
  const KEY = 'gr_toolbox_v1';
  const ANON_KEY = 'gr_anon_id';
  const GR_EVENTS_API = 'https://mbti-proxy-op9i.vercel.app/api/events/log';

  function fallbackId() {
    return 'gr_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 10);
  }

  function getAnonId() {
    try {
      let id = localStorage.getItem(ANON_KEY);
      if (!id) {
        id = crypto?.randomUUID ? crypto.randomUUID() : fallbackId();
        localStorage.setItem(ANON_KEY, id);
      }
      return id;
    } catch {
      return fallbackId();
    }
  }

  window.GR = window.GR || {};
  window.GR.anonId = window.GR.anonId || getAnonId();
  window.GR.userId = window.GR.anonId;

  function canonicalPath(input) {
    try {
      const u = new URL(input, location.origin);
      let p = u.pathname || '/';
      p = p.replace(/\/index\.html?$/i, '');
      p = p.replace(/\/+/g, '/');
      if (p.length > 1) p = p.replace(/\/$/, '');
      return p || '/';
    } catch {
      return '/';
    }
  }

  function makeHandleFromPath(pathname) {
    return pathname.replace(/\/+/g, '/').replace(/\/$/, '').split('/').slice(-1)[0] || 'home';
  }

  function readItems() {
    try {
      return JSON.parse(localStorage.getItem(KEY) || '[]');
    } catch {
      return [];
    }
  }

  function writeItems(items) {
    try {
      localStorage.setItem(KEY, JSON.stringify(items));
      document.dispatchEvent(new CustomEvent('gr:changed'));
    } catch {
      alert('Saving is unavailable in this browser mode.');
    }
  }

  function isSaved(handle) {
    return readItems().some(i => i.handle === handle);
  }

  function logEventToSupabase(eventType, eventData = {}) {
    try {
      fetch(GR_EVENTS_API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          user_id: window.GR?.anonId || null,
          event_type: eventType,
          page_path: location.pathname,
          page_title: document.title,
          event_data: eventData,
          created_at: new Date().toISOString()
        }),
        keepalive: true
      }).catch(() => {});
    } catch {}
  }

  function initSaveButton() {
    const btn = document.querySelector('.gr-save-to-toolbox');
    if (!btn) return;

    const title = btn.dataset.title || document.title.replace(/\s*\|.*$/, '').trim();
    const url = canonicalPath(btn.dataset.url || window.location.href);
    const handle = btn.dataset.handle || makeHandleFromPath(url);

    const summaryEl = document.querySelector('.gr-memory-line');
    const summary = summaryEl
      ? (summaryEl.getAttribute('data-gr-summary') || summaryEl.textContent || '').trim()
      : '';

    function render() {
      if (isSaved(handle)) {
        btn.classList.add('saved');
        btn.textContent = '✓ Saved to My Playbook';
      } else {
        btn.classList.remove('saved');
        btn.textContent = '+ Save to My Playbook';
      }
    }

    btn.addEventListener('click', function () {
      let items = readItems();

      if (isSaved(handle)) {
        items = items.filter(i => i.handle !== handle);
      } else {
        items.push({
          handle,
          title,
          url,
          addedAt: Date.now(),
          lastUpdated: Date.now(),
          status: 'not_started',
          appliedCount: 0,
          reviewCount: 0,
          notes: '',
          summary,
          nextAction: ''
        });

        logEventToSupabase('saved', {
          framework_slug: handle,
          title,
          url
        });
      }

      writeItems(items);
      render();
    });

    render();
  }

  function initPerItemButtons() {
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('.gr-add-to-toolbox');
      if (!btn) return;

      e.preventDefault();

      const label = btn.getAttribute('data-toolbox-label') || btn.textContent.trim() || 'Saved item';
      const explicitUrl = btn.getAttribute('data-toolbox-url');

      const scope = btn.closest('li') || btn.closest('.section-box') || document;
      const link = scope.querySelector('a[href]');
      const url = canonicalPath(explicitUrl || link?.href || '');

      if (!url) return;

      const handle = 'fw:' + url.replace(/[^\p{L}\p{N}]+/gu, '-').replace(/^-+|-+$/g, '');

      let items = readItems();

      if (isSaved(handle)) {
        items = items.filter(i => i.handle !== handle);
        btn.classList.remove('is-added');
        btn.textContent = '+ Add';
      } else {
        items.push({
          handle,
          title: label,
          url,
          addedAt: Date.now(),
          lastUpdated: Date.now(),
          status: 'not_started',
          appliedCount: 0,
          reviewCount: 0,
          notes: ''
        });

        btn.classList.add('is-added');
        btn.textContent = '✓ Added';

        logEventToSupabase('saved', {
          framework_slug: handle,
          title: label,
          url
        });
      }

      writeItems(items);
    });
  }

  function todayLocalKey() {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Europe/Brussels',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).formatToParts(new Date()).reduce((a,p) => {
    a[p.type] = p.value;
    return a;
  }, {});

  return `${parts.year}-${parts.month}-${parts.day}`;
}

function logPageView() {
  const btn = document.querySelector('.gr-save-to-toolbox');
  if (!btn) return;

  const url = canonicalPath(btn.dataset.url || window.location.href);
  const handle = btn.dataset.handle || makeHandleFromPath(url);

  const viewKey = `gr_viewed_${handle}_${todayLocalKey()}`;

  if (!sessionStorage.getItem(viewKey)) {
    sessionStorage.setItem(viewKey, '1');

    logEventToSupabase('viewed', {
      framework_slug: handle
    });
  }
}

  function onReady() {
    initSaveButton();
    initPerItemButtons();
    logPageView();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();